import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import "./index.scss";
import DevisService from "../../services/devis.service";

const EditDevis = ({
  show,
  handleClose,
  onUserUpdated,
  user,
  devis,
  fetchUserDevis,
}) => {
  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    company: "",
    birthDate: "",
    country: "",
    city: "",
    image: null,
    password: "",
    confirmPassword: "",
    status: "Nouveau",
    Role: "client",
    servicesDemandes: "",
    budgetEstime: "",
    currency: "",
    description: "",
    statut: "",
    dateSoumission: "",
    activitySector: "",
    pieceJointe: null,
    company: "",
    SIRET: "",
    SIREN: "",
    KBIS: "",
  });

  const roles = [
    { value: "admin", label: "Admin" },
    { value: "client", label: "Client" },
    { value: "gestionnaire", label: "Gestionnaire" },
  ];

  const devisstatut = [
    { value: "Nouveau", label: "Nouveau" },
    { value: "En cours", label: "En cours" },
    { value: "Traité", label: "Traité" },
  ];
  const deviscurency = [{ value: "EUR", label: "EUR" }];

  useEffect(() => {
    if (show && user) {
      setData({
        firstname: user?.firstname || "",
        lastname: user?.lastname || "",
        email: user?.email || "",
        phone: user?.phone || "",
        company: user?.company || "",
        birthDate: user?.birthDate || "",
        country: user?.country || "",
        city: user?.city || "",
        image: null,
        password: "",
        confirmPassword: "",
        status: user?.status || "Nouveau",
        Role: user?.Role || "client",
        servicesDemandes: user?.servicesDemandes || "",
        budgetEstime: user?.budgetEstime || "",
        currency: user?.currency || "",
        description: user?.description || "",
        statut: user?.statut || "",
        SIREN: user?.SIREN || "",
        SIRET: user?.SIRET || "",
        KBIS: user?.KBIS || "",
        dateSoumission: user?.dateSoumission
          ? new Date(user?.dateSoumission).toISOString().split("T")[0]
          : "",
        activitySector: user?.activitySector || "",
        pieceJointe: null,
        // SIRET: user?.SIRET || "",
        // SIREN: user?.SIREN || "",
        // KBIS: user?.KBIS || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" || name === "pieceJointe") {
      setData({ ...data, [name]: files[0] });
    } else if (name === "servicesDemandes") {
      const services = value.split(",").map((s) => s.trim());
      setData({ ...data, [name]: services });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in data) {
      if (data[key] !== undefined && data[key] !== null) {
        if (Array.isArray(data[key])) {
          data[key].forEach((item) => formData.append(key, item));
        } else {
          formData.append(key, data[key]);
        }
      }
    }

    try {
      await DevisService.updateDevis(user._id, formData, () => {
        onUserUpdated?.();
        fetchUserDevis();
        handleClose();
      });
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
    }
  };
  useEffect(() => {
    if (devis) {
      console.log("Devis sélectionné :", devis); // Vérifie si tu reçois bien les données ici
      
    }
  }, [devis]);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="custom-modal-width"
    >
      <Form onSubmit={handleSubmit} encType="multipart/form-data">
        <Modal.Header closeButton>
          <Modal.Title>Modifier Devis Client</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mailing-section p-5 modal-body">
          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">
              Services demandés
            </Form.Label>
            <Form.Control
              name="servicesDemandes"
              value={data?.servicesDemandes}
              onChange={handleChange}
              placeholder="Ex: Site web, Application mobile"
              required
            />
          </Form.Group>
          <div className="row">
            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  Budget estimé
                </Form.Label>
                <Form.Control
                  name="budgetEstime"
                  type="number"
                  value={data?.budgetEstime}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </div>

            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  Devise
                </Form.Label>
                <Form.Control
                  as="select"
                  name="currency"
                  value={data.currency}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Choisir une devise --</option>
                  {deviscurency.map((currency) => (
                    <option key={currency.value} value={currency.value}>
                      {currency.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </div>
          </div>
          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">
              Description
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={data?.description}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">Statut</Form.Label>
            <Form.Control
              as="select"
              name="statut"
              value={data.statut}
              onChange={handleChange}
              required
            >
              <option value="">-- Choisir status --</option>
              {devisstatut.map((statut) => (
                <option key={statut.value} value={statut.value}>
                  {statut.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">
              Date de soumission
            </Form.Label>
            <Form.Control
              type="date"
              name="dateSoumission"
              value={data?.dateSoumission}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <div className="row">
            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  Secteur d'activité
                </Form.Label>
                <Form.Control
                  name="activitySector"
                  value={data?.activitySector}
                  onChange={handleChange}
                  placeholder="Ex: Informatique, Santé..."
                  required
                />
              </Form.Group>
            </div>

            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  Entreprise
                </Form.Label>
                <Form.Control
                  name="company"
                  value={data?.company}
                  onChange={handleChange}
                  placeholder="Tapez le nom de l'entreprise"
                  required
                />
              </Form.Group>
            </div>
          </div>
{/* 
          <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  KBIS
                </Form.Label>
                <Form.Control
                  name="KBIS"
                  value={data?.KBIS}
                  onChange={handleChange}
                  placeholder="Ex: 123 456 789"
                />
              </Form.Group>
            </div>
      

          <div className="row">
            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  SIRET
                </Form.Label>
                <Form.Control
                  name="SIRET"
                  value={data?.SIRET}
                  onChange={handleChange}
                  placeholder="Ex: 123 456 789 00010"
                />
              </Form.Group>
            </div>

            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  SIREN
                </Form.Label>
                <Form.Control
                  name="SIREN"
                  value={data?.SIREN}
                  onChange={handleChange}
                  placeholder="Ex: 123 456 789"
                />
              </Form.Group>
            </div>
          </div> */}

          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">
              Pièce jointe
            </Form.Label>
            <Form.Control
              name="pieceJointe"
              type="file"
              onChange={handleChange}
      
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="none"
            className="AppButton secondary"
            onClick={handleClose}
          >
            ANNULER
          </Button>
          <Button variant="none" className="AppButton primary" type="submit">
            MODIFIER
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditDevis;
